import { ReactNode } from 'react';

import classNames from 'classnames';

import { Icon } from 'components/ui/general';

import styles from './Information.module.scss';

export interface InformationProps {
  children: ReactNode;
  color?: 'info' | 'success' | 'error' | 'warning'; // color names $all-colors
  icon?: boolean;
  className?: string;
}

export const Information = ({
  children,
  color = 'info',
  icon = true,
  className
}: InformationProps) => {
  if (children) {
    return (
      <div
        className={classNames(styles.root, className, {
          [styles[`${color}Color`]]: color
        })}
      >
        {icon && <Icon name="exclamation-circle" className={styles.icon} />}
        <div className={styles.children}>{children}</div>
      </div>
    );
  }

  return null;
};
